"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlWithStoredTrackingObject = exports.addUtmParameterToUrl = void 0;
var utmParameter_1 = require("../models/utmParameter");
var trackingObject_1 = require("../trackingObject");
var addUtmParameterToUrl = function (baseUrl, utmParameter) {
    var url = new URL(baseUrl);
    if (Object.values(utmParameter).length === 0) {
        return baseUrl;
    }
    // We need to clean the url of old utmParameter
    utmParameter_1.allUtmParameterKeys.forEach(function (key) {
        url.searchParams.delete(key);
    });
    Object.entries(utmParameter).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value) {
            url.searchParams.set(key, value);
        }
    });
    return url.href;
};
exports.addUtmParameterToUrl = addUtmParameterToUrl;
var urlWithStoredTrackingObject = function (baseUrl, cookies) {
    var trackingObject = trackingObject_1.getTrackingObject(cookies) || {};
    return [exports.addUtmParameterToUrl].reduce(function (url, call) { return call(url, trackingObject); }, baseUrl);
};
exports.urlWithStoredTrackingObject = urlWithStoredTrackingObject;
